
import React from 'react';
import { UseFormReturn } from "react-hook-form";
import { 
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage,
} from "@/components/ui/form";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { CampaignFormValues } from "./types/formTypes";

interface FrequencySectionProps {
  form: UseFormReturn<CampaignFormValues>;
}

const FrequencySection: React.FC<FrequencySectionProps> = ({ form }) => {
  return (
    <FormField
      control={form.control}
      name="frequency"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Frequentie</FormLabel>
          <Select 
            onValueChange={field.onChange} 
            defaultValue={field.value}
            value={field.value}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Selecteer frequentie" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <SelectItem value="once">Eenmalig</SelectItem>
              <SelectItem value="hourly">Elk uur</SelectItem>
              <SelectItem value="daily">Dagelijks</SelectItem>
              <SelectItem value="weekly">Wekelijks</SelectItem>
              <SelectItem value="monthly">Maandelijks</SelectItem>
              <SelectItem value="every_minute">Elke minuut</SelectItem>
              <SelectItem value="every_login">Elke login</SelectItem>
            </SelectContent>
          </Select>
          <FormDescription>
            Hoe vaak moet de modal worden getoond aan gebruikers?
          </FormDescription>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

export default FrequencySection;
